export default __webpack_public_path__ + "static/media/m3.5b67bab8.jpg";